export default {
  reportAProblem: {
    loading: false,
    error: null,
    reported: false,
  },
};
